import { render, staticRenderFns } from "./TranslationEditorLocale.vue?vue&type=template&id=1697d4ba"
import script from "./TranslationEditorLocale.vue?vue&type=script&lang=ts"
export * from "./TranslationEditorLocale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports